// 购物车相关的接口传入的ctSaleMode字段增加ALI_COLLECT和TAOBAO_COLLECT
// 分别为‘1688收藏夹货品’和‘淘宝收藏夹货品’

// 接口和购物车是同一个，收藏夹功能你根据传入查询的ctSaleMode来区分购物车和收藏夹就好了

const state = {
  aliCollectList: [],
  taobaoCollectList: [],
}

const getters = {
}

const mutations = {
  setAliCollectList (state, list) {
    state.aliCollectList = list
  },
  setTaobaoCollectList (state, list) {
    state.taobaoCollectList = list
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
